'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var Section = function Section(props) {
    var rest = (0, _blacklist2['default'])(props, 'isOpen', 'alwaysOpen');
    return _react2['default'].createElement(
        'div',
        _extends({
            className: (0, _classnames2['default'])('Section', {
                'Section-alwaysOpen': props.alwaysOpen,
                'Section-open': props.isOpen
            })
        }, rest),
        props.children
    );
};

Section.propTypes = {
    alwaysOpen: _propTypes2['default'].bool,
    isOpen: _propTypes2['default'].bool,
    style: _propTypes2['default'].object
};

module.exports = Section;

// expose the children to the top level export
module.exports.Header = require('./SectionHeader');
module.exports.Action = require('./SectionAction');
module.exports.Body = require('./SectionBody');


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Section.js
// module id = 329
// module chunks = 0